module.exports = __webpack_public_path__ + "img/1566776733.9b99a34a.jpg";